module.exports = __webpack_public_path__ + "static/media/iPhone-greenwoodback_bild.64c0e4cf.jpg";